import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import MfaRegistrationForm from "./MfaRegistrationForm";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png";
import IntlMessages from "../util/IntlMessages";
import qs from "qs";
import {isCurrentUserMemberOf} from "../util/bbHelpers";
import {HashLink as Link} from "react-router-hash-link";
import {userSignOut} from "../actions";

const RegisterMFAPage = (props) => {
    const {match, location} = props;
    const dispatch = useDispatch();

    const authUser = useSelector(({auth}) => auth.authUser);
    const {token} = useSelector(({auth})=>auth);
    const {didJustVerifyForMFA} = useSelector(({auth}) => auth.appMisc);
    const userMessage = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).message : null;
    const userMessageToDisplay = userMessage
        ? userMessage === "success"
            ? <span className={"d-inline"}>
                <h2 className={"d-inline"}><IntlMessages id={"event.userEmailVerified.title"}/> </h2>
                <p className={"d-inline"}> <IntlMessages id={"event.userEmailVerified.detail"}/></p>
            </span>
            : userMessage === "verified"
                ? <span className={"d-inline"}>
                {/*<h2 className={"d-inline"}><IntlMessages id={"event.userEmailVerifiedAlready.title"}/></h2>*/}
                <p className={"d-inline"}><IntlMessages id={"event.userEmailVerifiedAlready.detail"}/></p>
            </span>
                : <span>
                <h2 className={"d-inline"}><IntlMessages id={"event.userInactive.title"}/></h2>
                <p className={"d-inline"}><IntlMessages id={"event.userInactive.detail"}/></p>
            </span>
        :null;


    const isAdminStaff = isCurrentUserMemberOf(authUser,"admin") || isCurrentUserMemberOf(authUser, "staff");
    const emailVerified = authUser && authUser.user && authUser.user.is_activated;

    const handleLogout = () => {
        console.log("Logging out from confirm company page.");

        dispatch(userSignOut());
    }

    // useEffect(()=>{
    //     if(userMessage){
    //         console.log("found a usermessage on the redirect to addMFA")
    //         if(userMessage === 'success'){
    //             console.log("usermessage is success")
    //             showBBNotification(SUCCESS,
    //                 <IntlMessages id={"event.userEmailVerified.title"}/>,
    //                 <IntlMessages id={"event.userEmailVerified.detail"}/>,
    //                 true)
    //         }else if(userMessage === 'verified') {
    //             console.log("usermessage is verified")
    //             showBBNotification(WARNING,
    //                 <IntlMessages id={"event.userEmailVerifiedAlready.title"}/>,
    //                 <IntlMessages id={"event.userEmailVerifiedAlready.detail"}/>,
    //                 true)
    //         } else{
    //             console.log("usermessage is undefined")
    //             showBBNotification(DANGER,
    //                 <IntlMessages id={"event.userEmailVerifiedAlready.title"}/>,
    //                 <IntlMessages id={"event.userEmailVerifiedAlready.detail"}/>,
    //                 true)
    //         }
    //     }
    // }, [userMessage])

    useEffect(()=> {

        // if(authUser && authUser.user && authUser.user.is_activated){
        // showBBNotification(SUCCESS,
        //     <IntlMessages id={"event.userEmailVerified.title"}/>,
        //     <IntlMessages id={"event.userEmailVerified.detail"}/>,
        //     false)}

        if((didJustVerifyForMFA
            || (authUser
                && authUser.security
                && authUser.security.mfa_enabled))
            && authUser.customers.length === 0
            && !isAdminStaff
        ){
            props.history.push('/confirmNew');
        } else if(didJustVerifyForMFA || (authUser
            && authUser.security
            && authUser.security.mfa_enabled)){
            props.history.push('/board/BreachRisk/Business/Score');
        }
    },[authUser, token, didJustVerifyForMFA, emailVerified])

    return(
        <div className="app-login-container-wide d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
            <div className="app-login-main-content">

                <div className="app-logo-content-wide d-flex align-items-center justify-content-center">
                    <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
                        <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
                    </a>
                </div>

                {emailVerified
                    ? <div className="app-login-content-wide">

                        {userMessageToDisplay
                        && <div className={"row text-center mb-2 mt-0"}>
                            <div className={"col-1"}/>
                            <div className={"col bg-lighter-gray jr-border-radius"}>
                                {userMessageToDisplay}
                            </div>
                            <div className={"col-1"}/>
                        </div>}

                        <div className={"row"}>
                            <div className={"col"}>
                                <h1 className={""}><IntlMessages id="appModule.register.MFA"/></h1>
                                <h4 className={""}><IntlMessages id="appModule.register.MFA.details"/></h4>
                            </div>
                        </div>
                        <hr/>
                        <MfaRegistrationForm/>
                        {token && //If user is logged in, they need to logout, no access to dashboard
                            <div className={"row"}>
                                <div className={"col-12 text-right"}>
                                    <Link to="/signin" onClick={handleLogout} className={""}>
                                        <IntlMessages id="form.goSignIn"/>
                                    </Link>
                                </div>
                            </div>

                        }
                    </div>
                    : <div className="app-login-content-wide">
                        <div className={"row"}>
                            <div className={"col"}>
                                <h1> Verify Your Email To Continue Registration.</h1>
                            </div>
                        </div>
                        <p> The email address you provided has not been verified. Please check your email for a link to verify your address.</p>
                        {token && //If user is logged in, they need to logout, no access to dashboard
                            <div className={"row"}>
                                <div className={"col-12 text-right"}>
                                    <Link to="/signin" onClick={handleLogout} className={""}>
                                        <IntlMessages id="form.goSignIn"/>
                                    </Link>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default RegisterMFAPage